// libs
import styled from "@emotion/styled";

// constants
import { MWEB_HEADER_DISCOUNT_HEIGHT, MWEB_HEADER_HEIGHT } from "shared/styles/base";

export const Container = styled.div<{ allowPadding: boolean; isDiscountVisible?: boolean }>`
    ${({ allowPadding, isDiscountVisible = true }) => {
        if (allowPadding === false) {
            return ``;
        }

        if (isDiscountVisible) {
            return `
padding-top: ${MWEB_HEADER_DISCOUNT_HEIGHT}px;
`;
        } else {
            return `
padding-top: ${MWEB_HEADER_HEIGHT}px;
`;
        }
    }}
`;
